import clsx from 'clsx';
import { useRouter } from 'next/router';
import React, { ReactElement } from 'react';
import NextImage from 'next/image';
import { Button, ResponsiveText, Text } from '@/components';
import { CONTACT_SUPPORT_ROUTE, FAQ_ROUTE } from '@/types/routes';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';
import { SummarySection } from './components/summary-section';
import { Web3 } from './components/web3';
import { Partners } from './components/partners';

export type AboutPageProps = StyleProps & {
  // add props here
};

const TRM_LOGO = '/images/powered-by-trm.svg';
const TRM_HEIGHT = 40;
const TRM_WIDTH = 200;

const ROOT = makeRootClassName('About');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function AboutPage(props: AboutPageProps): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };
  const { push } = useRouter();

  return (
    <div className={clsx(ROOT, p.className)}>
      <div className={el`content`}>
        <Text as="h4" className={el`heading`}>
          Chainabuse is the leading reporting platform for malicious crypto
          activity worldwide. We are on a mission to make crypto safe and
          trusted for the next billion users.
        </Text>

        <Text type="body-md" className={el`sub-heading`}>
          We empower anyone, anywhere, to report malicious crypto activity and
          to learn about it to stay safe. We provide free support to victims.
        </Text>
        <Text type="body-md" className={el`sub-heading`}>
          We enable our Partners to bring more safety to their users, and we
          help Law Enforcement worldwide to accelerate case prioritization and
          investigations.
        </Text>
      </div>

      <SummarySection />

      <div className={el`faq-cta`}>
        <ResponsiveText type="h3" tabletType="h2">
          Want to know more?
        </ResponsiveText>
        <Button onPress={() => push(FAQ_ROUTE)} className={el`faq-cta-button`}>
          GO TO CHAINABUSE FAQS
        </Button>
      </div>
      <Partners />
      <div className={el`trm`}>
        <NextImage
          src={TRM_LOGO}
          width={TRM_WIDTH}
          height={TRM_HEIGHT}
          alt="TRM logo"
        />
      </div>
      <Web3 />
      <div className={el`footer`}>
        <div className={el`become-a-partner`}>
          <Button
            onPress={() => push(CONTACT_SUPPORT_ROUTE)}
            variant="secondary"
            className={el`become-a-partner-button`}
          >
            BECOME A PARTNER
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
